import appSettings from '../../../config/appSettings';

const quickQuoteInitialState = {
    applicationType: appSettings.onlyPersonalCustomer ? 'personal' : '',
    applicants: appSettings.onlyOneApplicant ? 1 : 0,
    mortgageType: '',
    applicantsIncome: appSettings.onlyOneApplicant
        ? [{
            amount: '',
            currency: 'gbp',
        }]
        : [],
    property: {
        estaminatedPropertyValue: {
            amount: '',
            currency: 'gbp',
        },
        estaminatedPropertyMonthlyRent: {
            amount: '',
            currency: 'gbp',
        },
    },
    requestedLoanAmount: {
        amount: '',
        currency: 'gbp',
    },
    requestedTimeSpan: 36,
    isPending: false,
    products: [],
};

export default quickQuoteInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/quickQuoteInitialState.js